import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(".section3 ul li").hover(function() {
  $(".section3 ul li .section-title").stop().slideUp();
  $(this).find(".section-title").stop().slideDown();
},function() {
  $(".section3 ul li .section-title").stop().slideUp();
})

var swiper = new Swiper(".mySwiper", {
  slidesPerView: "auto",
  centeredSlides: true,
  spaceBetween: 30,
  loop:true,
  observer: true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents: true,//修改swiper的父元素时，自动初始化swiper
  speed:4000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },

});     